export default __webpack_public_path__ + "images/c20e6cf869bfb3ab00359455533a41da-electronic_music.webp";